import { ChangeDetectorRef, Component, inject, input } from '@angular/core';
import { NaturalLanguageEditorKeyphraseAbstractDirective } from '../natural-language-editor-keyphrase.abstract.directive';

@Component({
  selector: 'ziro-natural-language-editor-datepicker',
  templateUrl: './natural-language-editor-datepicker.component.html',
  styleUrls: [
    '../natural-language-editor-keyphrase.component.scss',
    './natural-language-editor-datepicker.component.scss',
  ],
  providers: [
    { provide: NaturalLanguageEditorKeyphraseAbstractDirective, useExisting: NaturalLanguageEditorDatepickerComponent },
  ],
  standalone: false,
})
export class NaturalLanguageEditorDatepickerComponent extends NaturalLanguageEditorKeyphraseAbstractDirective<Date> {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  minDate = input<Date>();
  disabledDateTooltipText = input<string>('');
  externalHasValidationError = input<boolean>(false);

  onUpdate(update: Date): void {
    super.onUpdate(update);
    this.changeDetectorRef.detectChanges();
  }
}
